import Typography from '@/components/shared/typography/typography.component';
import { ImperfectionReportItem } from '@/types';
import UnFultyImprefectionItem from './unfultyImprefectionItem.component';

const AccordionGoodPartsContent = ({
    arr,
    IS_RTL,
}: {
    arr: ImperfectionReportItem[];
    IS_RTL: boolean;
}) => {
    return (
        <>
            {arr.map((item, index) => {
                let tags: string | null = null;
                if (item.tags) {
                    tags = item.tags
                        .map(item => (IS_RTL ? item.tag_ar : item.tag_en))
                        .join(' - ');
                }
                let isRemark = false;
                let remarkNotes: string[] | null = null;
                if (arr.length === 1 && item.item_type === 'TEXT_ONLY') {
                    isRemark = true;
                    remarkNotes = IS_RTL
                        ? item?.comment_ar?.split('/')
                        : item?.comment_en?.split('/');
                }
                if (isRemark) {
                    return (
                        <div
                            className="flex justify-between items-center"
                            key={`${item.name_en} accordion-item`}
                        >
                            <Typography
                                variant="body2Medium"
                                className="!text-gray-700"
                            >
                                {remarkNotes?.map(note => {
                                    return (
                                        <li key={`${note} remark-note`}>
                                            {note}
                                        </li>
                                    );
                                })}
                            </Typography>
                        </div>
                    );
                }
                return (
                    <UnFultyImprefectionItem
                        item={item}
                        tags={tags}
                        key={`${item.name_en}${index}`}
                        IS_RTL={IS_RTL}
                    />
                );
            })}
        </>
    );
};

export default AccordionGoodPartsContent;
